export default __webpack_public_path__ + "maps-examples-line-gradient-thumbnail-960-caa6bd8fa05ab464ba9e5b9a5c90945a.webp";